import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {HOME_MATCH_PREFERENCES_SURVEY_CONTENT} from "../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {DISCARD, SAVE} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;
const {LOCATION_APPLY, LOCATION_CANCEL} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const {CONFIRM: SUMMARY_CONFIRM} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT.SUMMARY;

interface IConfirmActionProps {
    compact?: boolean;
    isSaving: boolean;
    onConfirm: () => void;
}

export const HomeMatchPreferencesSurveyConfirmAction = (props: IConfirmActionProps) => {
    const {compact, isSaving, onConfirm} = props;

    return (
        <Button
            className={cx(surveyCtaStyle, compact && confirmButtonStyle)}
            disabled={isSaving}
            isLoading={isSaving}
            onClick={onConfirm}
            type="button"
            variant="filled_secondary"
        >
            {SUMMARY_CONFIRM}
        </Button>
    );
};

interface ISurveyActionsProps {
    compactSave?: boolean;
    isSaveDisabled?: boolean;
    isSaving: boolean;
    onDiscard: () => void;
}

export const HomeMatchPreferencesSurveyActions = (props: ISurveyActionsProps) => {
    const {compactSave, isSaveDisabled, isSaving, onDiscard} = props;

    return (
        <>
            <Button
                className={cx(surveyCtaStyle, discardButtonStyle)}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.DISCARD}
                disabled={isSaving}
                onClick={onDiscard}
                type="button"
                variant="none_secondary"
            >
                {DISCARD}
            </Button>

            <Button
                className={cx(surveyCtaStyle, compactSave && saveButtonStyle)}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.SAVE}
                disabled={isSaving || isSaveDisabled}
                isLoading={isSaving}
                type="submit"
                variant="filled_secondary"
            >
                {SAVE}
            </Button>
        </>
    );
};

interface ILocationActionsProps {
    onApply: () => void;
    onCancel: () => void;
}

export const HomeMatchPreferencesSurveyLocationActions = (props: ILocationActionsProps) => {
    const {onApply, onCancel} = props;

    return (
        <>
            <Button
                className={cx(surveyCtaStyle, discardButtonStyle)}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_CANCEL}
                onClick={onCancel}
                type="button"
                variant="none_secondary"
            >
                {LOCATION_CANCEL}
            </Button>

            <Button
                className={surveyCtaStyle}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_APPLY}
                onClick={onApply}
                type="button"
                variant="filled_secondary"
            >
                {LOCATION_APPLY}
            </Button>
        </>
    );
};

const surveyCtaStyle = css({
    height: "4.8rem",
    py: 0
});

const discardButtonStyle = css({
    px: 0,

    "& span": {
        letterSpacing: "0"
    }
});

const saveButtonStyle = css({
    px: 4
});

const confirmButtonStyle = css({
    ml: "auto",
    px: 4
});
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {HOME_MATCH_PREFERENCES_SURVEY_CONTENT} from "../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {DISCARD, SAVE} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;
const {LOCATION_APPLY, LOCATION_CANCEL} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const {CONFIRM: SUMMARY_CONFIRM} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT.SUMMARY;

interface IConfirmActionProps {
    compact?: boolean;
    isSaving: boolean;
    onConfirm: () => void;
}

export const HomeMatchPreferencesSurveyConfirmAction = (props: IConfirmActionProps) => {
    const {compact, isSaving, onConfirm} = props;

    return (
        <Button
            className={cx(surveyCtaStyle, compact && confirmButtonStyle)}
            disabled={isSaving}
            isLoading={isSaving}
            onClick={onConfirm}
            type="button"
            variant="filled_secondary"
        >
            {SUMMARY_CONFIRM}
        </Button>
    );
};

interface ISurveyActionsProps {
    compactSave?: boolean;
    isSaveDisabled?: boolean;
    isSaving: boolean;
    onDiscard: () => void;
}

export const HomeMatchPreferencesSurveyActions = (props: ISurveyActionsProps) => {
    const {compactSave, isSaveDisabled, isSaving, onDiscard} = props;

    return (
        <>
            <Button
                className={cx(surveyCtaStyle, discardButtonStyle)}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.DISCARD}
                disabled={isSaving}
                onClick={onDiscard}
                type="button"
                variant="none_secondary"
            >
                {DISCARD}
            </Button>

            <Button
                className={cx(surveyCtaStyle, compactSave && saveButtonStyle)}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.SAVE}
                disabled={isSaving || isSaveDisabled}
                isLoading={isSaving}
                type="submit"
                variant="filled_secondary"
            >
                {SAVE}
            </Button>
        </>
    );
};

interface ILocationActionsProps {
    onApply: () => void;
    onCancel: () => void;
}

export const HomeMatchPreferencesSurveyLocationActions = (props: ILocationActionsProps) => {
    const {onApply, onCancel} = props;

    return (
        <>
            <Button
                className={cx(surveyCtaStyle, discardButtonStyle)}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_CANCEL}
                onClick={onCancel}
                type="button"
                variant="none_secondary"
            >
                {LOCATION_CANCEL}
            </Button>

            <Button
                className={surveyCtaStyle}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_APPLY}
                onClick={onApply}
                type="button"
                variant="filled_secondary"
            >
                {LOCATION_APPLY}
            </Button>
        </>
    );
};

const surveyCtaStyle = css({
    height: "4.8rem",
    py: 0
});

const discardButtonStyle = css({
    px: 0,

    "& span": {
        letterSpacing: "0"
    }
});

const saveButtonStyle = css({
    px: 4
});

const confirmButtonStyle = css({
    ml: "auto",
    px: 4
});
